import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import { useTranslation } from 'react-i18next';

const Footer = (props) => {
    const { t } = useTranslation();
    return (
        <React.Fragment>
            <footer className={props.styles}>
                <Container fluid>
                    <Row>
                        <Col sm={12}>
                            <div className="text-sm-end d-sm-block">
                            {new Date().getFullYear()} © {t('Footer.CompanyName')} | {t('Footer.Description')}
                            </div>
                        </Col>
                    </Row>
                </Container>
            </footer>
        </React.Fragment>
    );
};

export default Footer;